module.exports = __webpack_public_path__ + "img/7.6ab8c1a5.png";